<template lang="pug">
	.election-year(v-if="years?.length > 1", :year="currentYear", :class="{ isMain }")
		.year-nav
			.year-nav_item(v-for="year in years", :class="{ current: year?.year?.toString() === currentYear.toString(), disabled: year.navDisabled, [year.year]: year.year }")
				.year-nav_item_inner(@click="navClick(year)")
					span.year-nav_item_text {{ year.label }}
					LiveBullet(v-if="year.live")

				Callout(v-if="year.navDisabled" :open="calloutOpen" @handleClick="handleCloseCallout")
					|Check back on Election Night for Live Results from the {{ year.year }} Election.
</template>
<script>
import Callout from '../Callout/Callout.vue';
import IconArrowDown from '../../assets/icon-chevron-down.svg';
import LiveBullet from '../LiveBullet/LiveBullet.vue';

export default {
  name: 'yearNav',
  props: {
    isMain: {},
    embed: {
      type: Boolean,
      default: false,
    },
    year: {},
    device: {}
  },
  data: () => ({
    'calloutOpen': false
  }),
  computed: {
    years() {
      const
        years = Object.keys(this.$store.state.elections).map( (key) => {
          const { year, live, enabled, order, navDisabled, navLabel } = this.$store.state.elections[key];
          return {
            year,
            label: this.isMain && !this.device?.match('mobile') ? navLabel : year,
            live,
            enabled,
            order,
            navDisabled,
            theme: year === this.currentYear ? 'blue' : 'border-only',
            showIcon: live
          };
        })
          .filter( (election) => election.enabled )
          .sort( (a, b) => a.order - b.order );

      return years;
    },
    currentYear() {
      console.log('currentYear', this.year, this.$store.state.currentYear);
      return this.year || this.$store.state.currentYear;
    },

  },
  methods: {
    navClick(year) {
      if (year.navDisabled) {
        this.calloutOpen = true;
      } else {

        if (this.embed) {
          this.$emit('update:changeYear', year.year);
        } else {
          this.$store.dispatch('CHANGE_YEAR', year.year);
        }
      }
    },
    handleCloseCallout() {
      this.calloutOpen = false;
    },
  },
  components: {
    Callout,
    IconArrowDown,
    LiveBullet,
  }
};
</script>
<style lang="scss">
	@import "src/core/scss/global-sass";

	.year-nav {
		display: flex;
		justify-content: center;
		position: relative;

		[election-embed="true"] & {
			margin-bottom: 0;//$m-spacing-x2;
		}

		.election-main & {
			margin: $m-spacing-x4 auto;
		}

		// .eui-button:not([showicon]) {
		// 	.eui-button_icon {display:none}
		// }

		&_item {
			position: relative;
			background: white;
			border: 1px solid rgba(0,0,0,0.8);
			border-width: 1px;
			width: 160px;
			cursor: pointer;
			transition: all 0.3s;
			margin-right: var(--spacing-unit);
			border-radius: 20px;

			&:last-child {
				margin-right: 0;
			}

			&_inner {
				display: flex;
				align-items: center;
				padding: var(--spacing-unit) var(--spacing-unit-x2);
				justify-content: center;

				[election-embed="true"] & {
					padding: var(--spacing-unit-x0_75) var(--spacing-unit);
				}
			}

			&.current {
				background: #000;
				color: white;
				border-width: 1px 0;
			}

			&:not(.current):hover {
				// opacity:0.5;
				border-color: #000;
			}

			&_text {
				@include font-title-xs;
				@include thaustalianFonts();
				line-height: 1.3;
				text-transform: capitalize;
			}

			.eui-live-bullet {
				width: 16px;
				height: 16px;
				margin-left: var(--spacing-unit-x0_5);
			}

			@include MQ_MobileOnly() {

				&_inner {
					// padding: var(--spacing-unit) var(--spacing-unit);
				}
				&_text {
					font-size: 15px;
				}
			}

			@include MQ_LowerThan(440px) {
				margin-right: var(--spacing-unit-x0_5);
				&_inner {
					padding: var(--spacing-unit-x0_5) var(--spacing-unit);
				}

				&_text {
					font-size: 14px;
				}

			}


		}

		.eui-callout {
			position: absolute;
			z-index: 100;
			left: 50%;
			transform: translateX(-50%);
			top: 100%;
			margin-top: $m-spacing-x3;
			@include font-base-m;
			@include thaustalianFonts();
			width: 320px;

			@include MQ_LowerThan(400px) {
				width: 60vw;
			}

		}
	}


</style>
